
import { Vue, Component } from 'vue-property-decorator'
import auth from '@/store/modules/AuthModule'

@Component
export default class LoginPage extends Vue {
  username = ''
  password = ''
  onLogin () {
    auth.service.login(this.username, this.password).then((response) => {
      auth.addToken(response.data.accessToken)
      window.sessionStorage.setItem('token', response.data.accessToken)
      this.$router.push('/')
    })
  }

  mounted () {
    const token = window.sessionStorage.getItem('token')
    if (token) {
      auth.addToken(token)
      this.$router.push('/')
    }
  }
}
